export enum SystemMessageType {
  WhatsNew,
  SystemMessage
}
